import { useParams } from 'react-router-dom';

import { Banner } from '@components/banner';
import { IconPublish } from '@components/icons/publish';
import { IconUnpublish } from '@components/icons/unpublish';
import { RelativeSpinner } from '@components/loading-spinner';
import { useScopedTranslate } from '@locale/translate';

import { config } from 'app-config';

import { useGetJob } from 'api/jobs/hooks';
import { useStore } from 'models/Provider';
import { Job } from 'types/jobs';

export const PreviewJob = () => {
  const { jobId } = useParams();
  const jobQuery = useGetJob(Number(jobId), jobId !== undefined);
  if (jobQuery.isLoading && jobQuery.fetchStatus !== 'idle') {
    return <RelativeSpinner />;
  }
  if (jobQuery.isSuccess) {
    return <RenderPreview job={jobQuery.data} />;
  }
  return <RelativeSpinner />;
};

const iconStyle = { transform: 'translateY(30px)' };

export const RenderPreview = ({ job }: { job: Job }) => {
  const { t } = useScopedTranslate(PreviewJobLocale);
  const { current } = useStore();

  const iframeUrl = `${config.CAREERS_URL}/${current.info.name}/${job.languages[0].language}/${job.id}?preview=${job.uuid}`;

  return (
    <>
      <Banner
        title={job.isPublished ? t('titlePublished') : t('titleNotPublished')}
        icon={
          job.isPublished ? <IconPublish style={iconStyle} /> : <IconUnpublish style={iconStyle} />
        }
      />
      <iframe
        title="career site job preview"
        src={iframeUrl}
        width="100%"
        height="100%"
        style={{ border: 'none' }}
      />
    </>
  );
};

const PreviewJobLocale = {
  en: {
    titleNotPublished: 'Job preview • This job has not been published',
    titlePublished: 'Job preview • This job is published',
  },
  is: {
    titleNotPublished: 'Forskoðun starfs • Þetta starf hefur ekki verið birt',
    titlePublished: 'Forskoðun starfs • Þetta starf er í loftinu',
  },
};
